import store from '@/store';

export const API_HOST = process.env.VUE_APP_API_HOST;
export const SHARE_HOST = process.env.VUE_APP_SHARE_HOST;

const endpoint = `${API_HOST}/graphql`;

export interface IQueryVariables {
  [varName: string]:
    | string
    | number
    | boolean
    | undefined
    | null
    | IQueryVariables
    | string[]
    | number[]
    | boolean[];
}

export interface IQueryError {
  message: string;
  path?: string[];
  state?: any;
}

export interface IRequestOptions {
  disableAuth?: boolean;
}

export const getAuthHeader = () => {
  const token = store.getters['auth/token'];
  return `Bearer ${token}`;
};

export const request = async (
  query: string,
  variables?: IQueryVariables,
  options?: IRequestOptions
): Promise<{ data: any; errors: IQueryError[] }> => {
  const headers: { [key: string]: string } = {
    'Content-Type': 'application/json',
  };

  // Add the auth token if it is provided
  if (
    (!options || !options.disableAuth) &&
    store.getters['auth/authenticated']
  ) {
    headers.Authorization = getAuthHeader();
  }

  if (process.env.NODE_ENV !== 'production') {
    // tslint:disable-next-line:no-console
    console.dir({ query, variables });
  }

  return fetch(endpoint, {
    method: 'POST',
    headers,
    body: JSON.stringify({ query, variables }),
  })
    .then(response => response.json())
    .then(json => ({ data: json.data, errors: json.errors }));
};

export interface IPage<T> {
  pageInfo: {
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    startCursor: string;
    endCursor: string;
  };
  edges: Array<{
    cursor: string;
    node: T
  }>;
  nodes: T[];
  nodeCount: number;
}

export interface IPaginationOptions {
  first?: number;
  last?: number;
  after?: string;
  before?: string;
}

export const requestPaginated = async<T>(
  queryName: string,
  query: string,
  pagination: IPaginationOptions = { },
  variables?: IQueryVariables,
  options?: IRequestOptions,
): Promise<IPage<T>> => {
  const { data, errors } = await request(query, { ...pagination, ...variables }, options);
  if (errors && errors.length) {
    throw new Error(errors.map(e => e.message).join('\n'));
  }
  
  return data[queryName];
};

export default request;
